import React, { useState } from 'react';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

interface EmailFormProps {
  initialEmail: string;
}

const EmailForm: React.FC<EmailFormProps> = ({ initialEmail }) => {
  const [email, setEmail] = useState(initialEmail);
  const { toast } = useToast();

  async function updateEmail(event: React.FormEvent) {
    event.preventDefault();
    try {
      const { error } = await supabase.auth.updateUser({ email });
      
      if (error) throw error;

      toast({
        title: "Email update initiated",
        description: "Please check your email to confirm the change.",
      });
    } catch (error) {
      console.error('Error updating email:', error);
      toast({
        title: "Error updating email",
        description: "Please try again later.",
        variant: "destructive",
      });
    }
  }

  return (
    <form onSubmit={updateEmail} className="space-y-4">
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
          Email
        </label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="max-w-xs"
        />
      </div>
      <Button type="submit">Update Email</Button>
    </form>
  );
};

export default EmailForm;